export const checkUrlExtension = (url: string, extension: string): boolean => {
  const urlExtension = url.split('.').pop().toLowerCase();

  return urlExtension === extension;
};
